module.exports = __webpack_public_path__ + "media/images/alambique-desktop-f283fb20fb263d1408c5d124d36247ec.jpg";